import { useSignal } from "#/use-signal";
import {
  currentBookIdSignal,
  currentChapterIdSignal,
  currentIndexSignal,
  currentTitleSignal,
  engineSignal,
  getEngines,
  getVoices,
  inactivityChapterLookbackSignal,
  isPlayingSignal,
  isTtsSupportedSignal,
  nextSentence,
  paragraphDelaySignal,
  pause,
  pitchSignal,
  play,
  prevSentence,
  privacySignal,
  rateSignal,
  resume,
  sentenceDelaySignal,
  serviceStoppedSignal,
  setEngine,
  setInactivityChapterLookback,
  setParagraphDelay,
  setPitch,
  setPrivacyMode,
  setRate,
  setSentenceDelay,
  setVoice,
  stop,
  syncSearchReplacePatterns,
  voiceSignal,
} from "./tts-store";

/** Thin facade over TTS signals + actions (no React context). */
export function useTts() {
  return {
    isPlaying: useSignal(isPlayingSignal),
    serviceStopped: useSignal(serviceStoppedSignal),
    currentBookId: useSignal(currentBookIdSignal),
    currentChapterId: useSignal(currentChapterIdSignal),
    currentTitle: useSignal(currentTitleSignal),
    currentIndex: useSignal(currentIndexSignal),
    rate: useSignal(rateSignal),
    pitch: useSignal(pitchSignal),
    sentenceDelay: useSignal(sentenceDelaySignal),
    paragraphDelay: useSignal(paragraphDelaySignal),
    engine: useSignal(engineSignal),
    voice: useSignal(voiceSignal),
    isTtsSupported: useSignal(isTtsSupportedSignal),
    inactivityChapterLookback: useSignal(inactivityChapterLookbackSignal),
    privacyMode: useSignal(privacySignal),
    play,
    pause,
    resume,
    stop,
    nextSentence,
    prevSentence,
    setRate,
    setPitch,
    setPrivacyMode,
    setSentenceDelay,
    setParagraphDelay,
    setInactivityChapterLookback,
    getVoices,
    setVoice,
    getEngines,
    setEngine,
    syncSearchReplacePatterns,
  };
}
